import { Box } from "@mui/material";
import type { ReactNode } from "react";

interface NoSelectWrapperProps {
	children: ReactNode;
}

export const NoSelectWrapper = ({ children }: NoSelectWrapperProps) => {
	const handleContextMenu = (e: React.MouseEvent) => {
		e.preventDefault();
	};

	const handleKeyDown = (e: React.KeyboardEvent) => {
		// Prevent Ctrl+C, Ctrl+A, Cmd+C, Cmd+A
		if (
			(e.ctrlKey || e.metaKey) &&
			(e.key === "c" || e.key === "a" || e.key === "C" || e.key === "A")
		) {
			e.preventDefault();
		}
	};

	const handleDragStart = (e: React.DragEvent) => {
		e.preventDefault();
	};

	return (
		<Box
			sx={{
				userSelect: "none",
				WebkitUserSelect: "none",
				MozUserSelect: "none",
				msUserSelect: "none",
			}}
			onContextMenu={handleContextMenu}
			onKeyDown={handleKeyDown}
			onDragStart={handleDragStart}
		>
			{children}
		</Box>
	);
};
